import React from 'react';
import { AppProps } from 'next/app';
import '../styles/globals.css';
import { useRouter } from 'next/router';
import Layout from '@/components/app/Layout';
import { Footer } from '@/components/app/Footer';
import AdminLayout from '@/components/app/admin/AdminLayout';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

function MyApp({ Component, pageProps }: AppProps) {
    const { locale, asPath } = useRouter();
    const currentUrl = asPath;

    i18n.use(initReactI18next).init({
      resources: {
        ko: {
          translation: {
            siteDescription: "알리익스프레스에서 핫딜을 놓치지 마세요! 스마트한 쇼핑으로 놀라운 할인 혜택을 누리세요!",
            footerCopyright: "HotAliDeal.com에 게재된 모든 상품 정보와 이미지의 저작권은 AliExpress와 각 판매자에게 있습니다.",
            more: "더보기",
            viewMore: "더보기",
            showMore: "더보기",
            hotDeals: "핫딜 상품",
            all: "전체",
            privacyPolicy: "개인정보 처리방침",
            footerText: "HotAliDeal.com은 제휴 마케팅 활동의 일환으로 수수료를 받을 수 있습니다.",
            menu: "메뉴",
            close: "닫기",
            copy: "복사",
            promoCode: "프로모션 코드",
            copiedPromoCodeMessage: "프로모션 코드가 복사되었습니다.",
            productDescription: "상품 정보",
            relatedItems: "연관 상품",
            buyOnAliExpress: "AliExpress에서 구매",
            sold: "누적 판매",
            expires: "유효기간",
            discount: "할인",
            averageReviewRating: "평균 리뷰 평점",
            search: "검색...",
            searchResults: "{{value}} 개의 검색 결과",
            termsOfService: "서비스 약관",
            about: "사이트 소개",
            reviews: "리뷰",
            checkReviewsOnAliExpress: "AliExpress에서 리뷰 보기",
          }
        },
        ja: {
          translation: {
            siteDescription: "アリエクスプレスでお得なセールをお見逃しなく！スマートに買い物して、驚きの割引を楽しもう！",
            footerCopyright: "HotAliDeal.comに掲載されているすべての商品情報と画像の著作権はAliExpressと各販売者に帰属します。",
            more: "もっと見る",
            viewMore: "もっと見る",
            showMore: "もっと見る",
            hotDeals: "お買い得商品",
            all: "すべて",
            privacyPolicy: "プライバシーポリシー",
            footerText: "HotAliDeal.comはアフィリエイトマーケティング活動の一環として手数料を得る場合があります。",
            menu: "メニュー",
            close: "閉じる",
            copy: "コピー",
            promoCode: "プロモーションコード",
            copiedPromoCodeMessage: "プロモーションコードがコピーされました。",
            productDescription: "概要",
            relatedItems: "関連アイテム",
            buyOnAliExpress: "AliExpressで購入",
            sold: "販売済み",
            expires: "有効期限",
            discount: "割引",
            averageReviewRating: "平均レビュー評価",
            search: "検索...",
            searchResults: "{{value}} 件の検索結果",
            termsOfService: "サービス規約",
            about: "サイトについて",
            reviews: "レビュー",
            checkReviewsOnAliExpress: "AliExpressでレビューを見る",
          }
        },
        en: {
          translation: {
            siteDescription: "Get hot deals on AliExpress and enjoy incredible savings while shopping smarter!",
            footerCopyright: "The copyright for all product information and images on HotAliDeal.com belongs to AliExpress and the respective sellers.",
            more: "More",
            viewMore: "View More",
            showMore: "Show More",
            hotDeals: "Hot Deals",
            all: "All",
            privacyPolicy: "Privacy Policy",
            footerText: "HotAliDeal.com may earn a commission as part of its affiliate marketing activities.",
            menu: "Menu",
            close: "Close",
            copy: "Copy",
            promoCode: "Promo Code",
            copiedPromoCodeMessage: "The promo code has been copied.",
            productDescription: "Description",
            relatedItems: "Related items",
            buyOnAliExpress: "Buy on AliExpress",
            sold: "sold",
            expires: "Expires",
            discount: "Discount",
            averageReviewRating: "Average Review Rating",
            search: "Search...",
            searchResults: "{{value}} results",
            termsOfService: "Terms of Service",
            about: "About",
            reviews: "Reviews",
            checkReviewsOnAliExpress: "Check Reviews on AliExpress",
          }
        },
        ru: {
          translation: {
            siteDescription: "Не упустите горячие предложения на AliExpress и наслаждайтесь невероятными скидками, покупая более умно!",
            footerCopyright: "Авторское право на всю информацию о продукте и изображения на HotAliDeal.com принадлежит AliExpress и соответствующим продавцам.",
            more: "Больше",
            viewMore: "Посмотреть больше",
            showMore: "Показать больше",
            hotDeals: "Горячие предложения",
            all: "Все",
            privacyPolicy: "Политика конфиденциальности",
            footerText: "HotAliDeal.com может получать комиссию в рамках своей партнерской маркетинговой деятельности.",
            menu: "Меню",
            close: "Закрыть",
            copy: "Копировать",
            promoCode: "Промо-код",
            copiedPromoCodeMessage: "Промо-код был скопирован.",
            productDescription: "Описание товара",
            relatedItems: "Связанные товары",
            buyOnAliExpress: "Купить на AliExpress",
            sold: "продано",
            expires: "Истекает",
            discount: "Скидка",
            averageReviewRating: "Средний рейтинг отзывов",
            search: "Поиск...",
            searchResults: "{{value}} результатов",
            termsOfService: "Условия использования",
            about: "О нас",
            reviews: "Отзывы",
            checkReviewsOnAliExpress: "Посмотреть отзывы на AliExpress",
          }
        },
        es: {
          translation: {
            siteDescription: "¡No te pierdas las ofertas de AliExpress y disfruta de increíbles ahorros comprando de forma más inteligente!",
            footerCopyright: "Los derechos de autor de toda la información del producto y las imágenes en HotAliDeal.com pertenecen a AliExpress y a los vendedores respectivos.",
            more: "Más",
            viewMore: "Ver más",
            showMore: "Ver más",
            hotDeals: "Ofertas",
            all: "Todos",
            privacyPolicy: "Política de privacidad",
            footerText: "HotAliDeal.com puede recibir una comisión como parte de sus actividades de marketing de afiliación.",
            menu: "Menú",
            close: "Cerrar",
            copy: "Copiar",
            promoCode: "Código promocional",
            copiedPromoCodeMessage: "El código promocional ha sido copiado.",
            productDescription: "Descripción del producto",
            relatedItems: "Artículos relacionados",
            buyOnAliExpress: "Comprar en AliExpress",
            sold: "vendido",
            expires: "Caduca",
            discount: "Descuento",
            averageReviewRating: "Calificación promedio de la reseña",
            search: "Buscar...",
            searchResults: "{{value}} resultados",
            termsOfService: "Términos de servicio",
            about: "Acerca de",
            reviews: "Reseñas",
            checkReviewsOnAliExpress: "Ver reseñas en AliExpress",
          }
        },
      },
      lng: locale,
      fallbackLng: 'en-US',
      interpolation: {
        escapeValue: false,
      },
    });

    const { categories } = pageProps;

    return (
      <>
        { currentUrl.startsWith('/admin') &&
          // Admin 페이지에서는 AdminLayout 사용
          <AdminLayout>
            <Component {...pageProps} />
          </AdminLayout>
        }
        { !currentUrl.startsWith('/admin') &&
          // 그 외의 경우 일반 Layout 사용
          <>
            <Layout categories={categories}>
              <Component {...pageProps} />
            </Layout>
            <Footer />
          </>
        }
      </>
    );
}

export default MyApp;